module.exports = __webpack_public_path__ + "static/media/wizualizacja-96.b44363a9.png";